<section [formGroup]="card">
  <section>
    <div class="col-md-12">
      <mat-form-field appearance="fill" class="col-md-3">
        <mat-label>Available Subtypes</mat-label>
        <mat-select
          multiple
          formControlName="availableSubTypes"
          (selectionChange)="subTypeChange()"
        >
          <mat-option
            *ngFor="let availableSubType of getSubTypes()"
            [value]="availableSubType"
          >
            {{ availableSubType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </section>
</section>
